import CustomTextField from '../../common/CustomTextField/CustomTextField';
import {
    Button,
    createStyles,
    FormGroup,
    InputAdornment,
    makeStyles,
} from '@material-ui/core';
import {Add, AddCircleRounded} from '@material-ui/icons';
import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import i18nNamespaces from '../../../const/i18nNamespaces';
import {VZ_LIGHT_GREY, PRIMARY_RED} from '../../../const/colors';
import {useAppDispatch} from '../../../hooks/customReduxHooks';
import {authCodeSpecified} from '../../../store/prescriptionHistorySlice';

const useStyles = makeStyles(() =>
    createStyles({
        container: {
            paddingTop: 16,
        },
        button: {
            borderRadius: '0 3px 3px 0',
            height: 56,
            border: 'none',
            width: 56
        },
        icon: {
            color: PRIMARY_RED,
        },
        adornment: {
            marginRight: '-14px',
        },
    }),
);

type AccessCodeInputProps = {
    disabled: boolean;
    errorText: string;
    onSubmit: () => void;
};
const AccessCodeInput = ({
    disabled,
    onSubmit,
    errorText,
}: AccessCodeInputProps) => {
    const {t} = useTranslation(i18nNamespaces.PRESCRIPTIONS);
    const classes = useStyles();
    const [code, setCode] = useState<string>('');
    const dispatch = useAppDispatch();

    const handleSubmit = () => {
        dispatch(authCodeSpecified(code));
        onSubmit();
    };

    return (
        <form
            onSubmit={e => {
                e.preventDefault();
                handleSubmit();
            }}
        >
            <FormGroup style={{marginBottom: 30}}>
                <CustomTextField
                    disabled={disabled}
                    id="code"
                    name="code"
                    type="text"
                    onChange={v => setCode(v.target.value)}
                    error={errorText !== null && errorText !== undefined && errorText !== ''}
                    helperText={t(errorText)}
                    placeholder={t('enterTheCode')}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment
                                position="end"
                                className={classes.adornment}
                            >
                                <Button
                                    className={classes.button}
                                    size="small"
                                    color="secondary"
                                    type="submit"
                                    disabled={disabled}
                                >
                                    <AddCircleRounded className={classes.icon} />
                                </Button>
                            </InputAdornment>
                        ),
                    }}
                />
            </FormGroup>
        </form>
    );
};

export default AccessCodeInput;
